// extracted by mini-css-extract-plugin
export default {"dotsWrapper":"_8a351c26","spinContainer":"_ce3573ba","list":"_4840087b","carouselItem":"_417d03fc"};